export function isNotNullAndDefined<T>(arg: T | null | undefined): arg is T {
  return arg != null && typeof arg !== `undefined`;
}
